import axios from 'axios';
import qs from 'qs';
import { getEndpointUrl } from '@/config/ConfigProvider';
import eventBus from '@/foundations/services/eventBus';

const mediaFragmentsPath = 'content';

export type UploadParams = {
  subType?:
    | 'audio'
    | 'epub'
    | 'video'
    | 'bookCover'
    | 'content'
    | 'subtitles'
    | 'narration'
    | 'preview'
    | 'materialPreview';
  language?: string;
  uploadId?: string;
  market?: string;
  extractCover?: boolean;
  uploadedBy?: string;
  pageNr?: number;
};

export type RemoveParams = {
  subType: 'audio' | 'epub' | 'video' | 'bookCover' | 'materialPreview';
  language?: string;
  market?: string;
  fileId?: string;
};

export type QueryParams = {
  [key: string]: string | number | boolean;
};

const mediaProvider = {
  getMediaUploadUrl: (resourceId: string, fileName: string, params: UploadParams) =>
    axios
      .get(`${getEndpointUrl(mediaFragmentsPath)}/${resourceId}/upload`, { params: { ...params, fileName } })
      .then((response) => response.data.url),
  getMediaDownloadUrl: async (resourceId: string, queryParams: QueryParams) => {
    const urlQs = qs.stringify(queryParams, { addQueryPrefix: true });
    return axios
      .get(`${getEndpointUrl(mediaFragmentsPath)}/${resourceId}/contentUrls${urlQs}`)
      .then((response) => response.data.url);
  },
  downloadMedia: (url: string) => {
    const conf = {
      url,
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return axios
      .create(conf)
      .get(url)
      .then((response) => response.data);
  },
  uploadMedia: (resourceId: string, file: File, params: UploadParams = {}) =>
    mediaProvider
      .getMediaUploadUrl(resourceId, file.name, params)
      .then((url) =>
        fetch(url, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type,
          },
        })
          .then((_data) => {
            eventBus.$emit('mediaFragment.mediaUploaded');
            eventBus.$emit('snackbar.open', 'Media uploaded successfully!');
          })
          .catch((error) => {
            eventBus.$emit('snackbar.open', error.message);
          }),
      )
      .catch((error) => {
        console.log(file);
        console.log(error);
      }),
  toggleMediaState: (resourceId: string, isPublished: boolean) => {
    const toggleType = isPublished ? 'disable' : 'enable';
    const toggleLabel = isPublished ? 'disabled' : 'published';
    return axios
      .post(`${getEndpointUrl(mediaFragmentsPath)}/${resourceId}/${toggleType}`)
      .then((_data) => {
        eventBus.$emit('snackbar.open', `Content ${toggleLabel} successfully!`);
      })
      .catch((error) => {
        eventBus.$emit('snackbar.open', error.message);
      });
  },
  removeMedia: (resourceId: string, _params: RemoveParams) => {
    const urlQs = qs.stringify(_params);
    const params = urlQs ? `?${urlQs}` : '';

    return axios
      .delete(`${getEndpointUrl(mediaFragmentsPath)}/${resourceId}/file${params}`)
      .then((_data) => {
        eventBus.$emit('snackbar.open', `Content removed successfully!`);
      })
      .catch((error) => {
        eventBus.$emit('snackbar.open', error.message);
      });
  }
};

export default mediaProvider;
